import {css, SerializedStyles} from '@emotion/react';
import styled from '@emotion/styled';
import {mixinFocus, mixinTruncate} from 'webapp-lib/styling';

import {Props} from '.';

const booleanInputStyles = (): SerializedStyles => css`
  position: relative;
  display: flex;
  align-items: center;
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  user-select: none;
  color: var(--color-core-black);
  line-height: 24px;

  input {
    margin: 0;
    -webkit-appearance: none;
  }
`;

export const TagNameWrapper = styled.span`
  ${mixinTruncate}
`;

export const StyledTag = styled('label', {
  shouldForwardProp: (prop: string) => !['color'].includes(prop),
})<Props>`
  ${booleanInputStyles};
  ${({inline}): string => (inline ? 'display: inline-block;' : '')}
  font-size: var(--tag-font-size);
  font-weight: var(--tag-font-weight);
  color: ${({alternativeStyle}): string =>
    alternativeStyle
      ? 'var(--color-core-white)'
      : 'var(--color-core-dark-grey)'};
  ${({fitToMultiLines}) =>
    fitToMultiLines ? 'line-height: 18px;' : 'height: 24px;'};
  padding: 0 ${({alternativeStyle}): number => (alternativeStyle ? 4 : 12)}px;
  background-color: ${(props): string =>
    props.alternativeStyle
      ? props.color || 'var(--color-state-active)'
      : props.checked
        ? props.color
        : 'var(--color-core-white)'};
  border: var(--regular-border-width) solid
    ${({color}) => color || 'var(--color-state-active)'};
  border-radius: 2px;
  cursor: ${({alternativeStyle}): string =>
    alternativeStyle ? 'initial' : 'pointer'};
  transition: background-color 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  input {
    outline: none;
  }

  :focus-within {
    ${({alternativeStyle}): string | SerializedStyles =>
      alternativeStyle ? '' : mixinFocus}
  }
`;
